import React from "react";
import CommonMap from "../../components/maps/CommonMap";
import { Helmet } from "react-helmet-async";
import { withCommonMapProvider } from "../../utils/withCommonMapProvider";

const MapDashboard = ({ type, children }) => {
  return (
    <React.Fragment>
      <Helmet defer={false} title="Map" />
      <CommonMap
        height="80vh"
        type={type}
        showNearByAssets={true}
        showTrackingSearch={true}
        showHashTagFilter={true}
        showCategoryFilter={true}
      />
    </React.Fragment>
  );
};

export default withCommonMapProvider(MapDashboard);
